import { supabase } from '../../lib/supabase'
import type { NotificationEventKind } from './notificationStore'

// The event kinds the account has turned off. A kind with no row is on, so
// this is the whole of what a preference says.
export async function getTurnedOffKinds(userId: string): Promise<Set<NotificationEventKind>> {
  const { data, error } = await supabase.from('notification_preferences').select('event_kind, in_app').eq('profile_id', userId)
  if (error || !data) return new Set()
  return new Set((data as { event_kind: NotificationEventKind; in_app: boolean }[]).filter((row) => !row.in_app).map((row) => row.event_kind))
}

// Sets the in-app notice for each of the kinds, returning whether every write
// landed. A notice for a kind turned off is not stored from then on; one
// already received stays.
export async function setKindsOn(userId: string, kinds: NotificationEventKind[], on: boolean): Promise<boolean> {
  const results = await Promise.all(
    kinds.map((kind) =>
      supabase
        .from('notification_preferences')
        .upsert({ profile_id: userId, event_kind: kind, in_app: on, updated_at: new Date().toISOString() }, { onConflict: 'profile_id,event_kind' }),
    ),
  )
  return results.every((result) => !result.error)
}
